import moment from 'moment';
import { useEffect, useMemo, useState } from 'react';

interface Props {
  when: string;
}

const MINUTE_MS = 60 * 1000;
const DAY_MS = 24 * 60 * MINUTE_MS;

const useRelativeTime = (when: string) => {
  const [relativeTime, setRelativeTime] = useState<string>('Checking...');

  useEffect(() => {
    const parsed = moment(when);
    if (!parsed.isValid()) {
      // FIXME
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setRelativeTime(when);
      return;
    }

    setRelativeTime(parsed.fromNow());
    const diffMs = Math.abs(moment().diff(parsed));
    if (diffMs > DAY_MS) {
      // Take the easy way out. Feel free to update this to be a more
      // complete implementation if you care.
      return;
    }

    const interval = setInterval(() => {
      setRelativeTime(parsed.fromNow());
    }, MINUTE_MS);

    return () => {
      clearTimeout(interval);
    };
  }, [when]);

  return relativeTime;
};

export const RelativeTime: React.FC<Props> = ({ when }) => {
  const { dateTime, title } = useMemo(() => {
    const date = new Date(when);
    const dateTime = date.toISOString();
    const title = date.toLocaleString();

    return { dateTime, title };
  }, [when]);

  const relative = useRelativeTime(when);

  return (
    <time dateTime={dateTime} title={title}>
      {relative}
    </time>
  );
};

export const ExactAndRelativeTime: React.FC<Props> = ({ when }) => {
  const { dateTime, title } = useMemo(() => {
    const date = new Date(when);
    const dateTime = date.toISOString();
    const title = date.toLocaleString();

    return { dateTime, title };
  }, [when]);

  const relative = useRelativeTime(when);
  return (
    <time dateTime={dateTime} title={title}>
      {title} ({relative})
    </time>
  );
};
